export class Storage {

	STORAGE_KEY = "meal_plan_recipe_ids";

	constructor(key) {
		if (key) { 
			this.STORAGE_KEY = key;
		}
	}

	addItem(item) {
		const set = new Set(this.getAllItems());
		set.add(item);
		const arr = [...set];
		this.saveItems(arr);
		return arr;
	}

	removeItem(item) {
		const set = new Set(this.getAllItems());
		set.delete(item);
		const arr = [...set];
		this.saveItems(arr);
		return arr;
	}

	toggleItem(item) {
		const set = new Set(this.getAllItems());
		if (set.has(item)) {
			set.delete(item);
		} else {
			set.add(item);
		}
		const arr = [...set];
		this.saveItems(arr);
		return arr;
	}

	hasItem(item) {
		const set = new Set(this.getAllItems());
		return set.has(item);
	}

	saveItems(items) {
		this.lsSetItem(this.STORAGE_KEY, items);
	}

	getAllItems() {
		return this.lsGetItem(this.STORAGE_KEY) || [];
	}

	lsSetItem(key, value) {
		localStorage.setItem(key, JSON.stringify(value));
	}

	lsGetItem(key) {
		return JSON.parse(localStorage.getItem(key));
	}

}

const db = new Storage();

export default db;